/* Установщик «Кавер»: объект в window на том месте порядка скриптов, где стоял assets/bot-cover.js.
   В серверном режиме движок шаблона получает сервер экрана (cover-server.ts) и экран cover встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createCover } from './engine';
import { createCoverServer, registerCoverEngine } from './cover-server';

export function installCover() {
  const server = isServerMode();
  createCover(server ? createCoverServer : null);
  if (server) registerCoverEngine();
}
